import { useEffect, useState } from "react";

export function useRecaptchaReady() {
  const [recaptchaReady, setRecaptchaReady] = useState(false);

  useEffect(() => {
    const checkRecaptcha = () => {
      if (window.grecaptcha && window.grecaptcha.execute) {
        setRecaptchaReady(true);
      } else {
        setRecaptchaReady(false);
      }
    };

    const interval = setInterval(() => {
      checkRecaptcha();
    }, 500);

    // 最多检查 5 秒钟
    const timeout = setTimeout(() => {
      clearInterval(interval);
      checkRecaptcha();
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  return recaptchaReady;
}


export async function verifyRecaptcha(recaptchaRef, setError) {
  try {
    const recaptchaToken = await recaptchaRef.current.executeAsync();
    const recaptchaResponse = await fetch("/api/recaptcha/verify-recaptcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ recaptchaToken }),
    });
    const recaptchaResult = await recaptchaResponse.json();
    recaptchaRef.current.reset();
    if (!recaptchaResult.success) {
      setError('ReCAPTCHA validation failed, your payment cannot be processed.');
      return false;
    }
    return true;
  } catch (err) {
    setError('ReCAPTCHA validation error, your payment cannot be processed.');
    return false;
  }
}
